import { ACCOUNT_DETAILS, ACCOUNT_DETAILS_ERROR, ACCOUNT_DETAILS_HIDE_ERROR, ACCOUNT_DETAILS_START_LOADER, ACCOUNT_DETAILS_STOP_LOADER, } from "../interface/IGetAccountDetails";
const initState = {
    data: {
        registeredGuestAccount: false,
        clientAccount: false,
        status: false,
        guestId: "",
        mobile: "",
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const getAccountDetails = (state = initState, action) => {
    switch (action.type) {
        case ACCOUNT_DETAILS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case ACCOUNT_DETAILS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case ACCOUNT_DETAILS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case ACCOUNT_DETAILS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case ACCOUNT_DETAILS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default getAccountDetails;
